import { Component, OnInit, Input, ElementRef, ViewChild, Output, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { EventEmitter } from '@angular/core';
import { HeaderUtilsService } from '../header-utils.service';
import { ChatService } from 'src/app/services/chat.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { SearchEngineService } from 'src/app/services/search-engine/search-engine.service';
import { Storage } from '@ionic/storage';
import { encodeURL } from 'src/app/services/parseURL';
import { Events,NavController } from '@ionic/angular';
import { VendorService } from "src/app/services/vendor/vendor.service";


@Component({
    selector: 'app-header-four',
    templateUrl: './header-four.component.html',
    styleUrls: ['./header-four.component.scss'],
})
export class HeaderFourComponent implements OnInit {
    @Input() headerData: any;
    @Input() data: any;
    @Input() region: any;
    @Output() openRegionModalEvent = new EventEmitter();
    @Input() stickyHeader: boolean;
    @Output() getStickyHeight = new EventEmitter();

    @ViewChild('navMenu', {
        static: false
    }) navMenu: ElementRef;


    loginStatus = false;
    isPriceReq: boolean;
    showPrices: boolean;
    page: number = 0;
    stickyHeight = 150;
    isIOS;
    role: any;
    userId: string = '';
    priceForRetail = false;
    currencyCode: any;
    RFQFeature = false;
    searchText = '';
    displaySearchResult;
    isOpenSearch = environment.openAlgoliaSearch;
    showSearchLoader: boolean = false;
    showNoProducts = false;
    algoliaProducts: any[] = [];
    searchsubscribed: boolean = false;
    noMoreProducts: boolean = false;
    typingTimer;
    showMenu: boolean = false;
    doneTypingInterval = 1000;


    constructor(
        public userService: UserService,
        private headerUtilsService: HeaderUtilsService,
        private utilsService: UtilsService, 
        private chatService: ChatService,
        private authService: AuthService,
        private router: Router,
        private searchEngineService: SearchEngineService,
        private navCtrl: NavController,
        private vendorService: VendorService,
        private storage: Storage,
        ) { }

    dropMenu() {
        const navMenu = this.navMenu.nativeElement.parentNode.classList;
        console.log(navMenu.toggle('dBlock'));
    }

    openRegionModal(type) {
        this.openRegionModalEvent.emit(type);
    }

    async ngOnInit() {
        if (this.data) {
            this.role = this.data.role;
            this.priceForRetail = this.data.priceForRetail;
            this.currencyCode = this.data.currencyCode;
            this.RFQFeature = this.data.loginStatus;
        }

        this.loginStatus = this.headerUtilsService.getLoginStatus();
    }

    logout() {
        this.headerUtilsService.logout();
    }
    async openLoginModal() {
        this.utilsService.openLoginModal();
    }
    openSearchPage() {
        this.headerUtilsService.openSearchPage();
    }
    
checkPdtStock(pdt) {
    let isOutOfStock = false;
    if (!pdt.isPriceList) {
      if (pdt.productQty === '0' && pdt.stopWhenNoQty) {
        isOutOfStock = true;
      }
    } else {
      if (pdt.stopWhenNoQty) {
        for (let pl of pdt.priceList) {
          if (pl.totalQuantity !== '0') {
            isOutOfStock = false;
            break;
          } else {
            isOutOfStock = true;
          }
        }
      }
    }
    return isOutOfStock;
}

async loadMoreProducts() {
    this.page = this.page + 1;
    const searchRes = await this.searchEngineService.alogoliaSearchProducts(
      this.searchText,
      this.page,
      'existing_search'
    );
    this.processSearchRes(searchRes);
}
onClickVendor(product) {
  this.router.navigate([
    `vendor-info/${encodeURL(product.vendorName)}/${product.vendorId}`,
  ]);
}
showVendorInfo(vendorName) {
  return this.vendorService.vendorSettings.showVendorInfo && vendorName;
}
processSearchRes(searchRes) {
    if (searchRes) {
      switch (searchRes.response) {
        case 'no_products':
          this.showSearchLoader = false;
          this.showNoProducts = true;
          break;

        case 'no_more_products':
          this.noMoreProducts = true;
          this.showSearchLoader = false;
          break;

        case 'products_available':
          this.storage.get('userSubRole').then((subRole) => {
            if (subRole && subRole === 'retailer' && this.priceForRetail) {
              searchRes.products.forEach((pdt) => {
                let retailDiscount = pdt.retailDiscount
                  ? pdt.retailDiscount
                  : 0;

                if (retailDiscount) {
                  if (!pdt.isPriceList) {
                    pdt.discountedPrice =
                      pdt.prodPrice - pdt.prodPrice * (retailDiscount / 100);
                  } else {
                    pdt.priceList.forEach((pl) => {
                      pl.discountedPrice =
                        pl.price - pl.price * (retailDiscount / 100);
                    });
                  }
                }
              });
            }
            console.log('products in searchhhh', searchRes.products);
            this.displaySearchResult = true;
            this.algoliaProducts = searchRes.products;
            this.showSearchLoader = false;
            this.showNoProducts = false;
          });
      }
    }
  }
  goToSearchResults() {
    if (this.searchText) {
      this.navCtrl.navigateRoot([
        `search-results/${encodeURL(this.searchText)}`,
      ]);
    }
}
closeMenu() {
  this.showMenu = false;
}
  onClickProduct(pdt: any) {
    const name = encodeURL(pdt.prodName);
    // if (pdt.ptype === 'child') {
    //     this.router.navigate([`product-details/${name}/${pdt.parentId}`]);
    // } else {
    //     this.router.navigate([`product-details/${name}/${pdt.objectID}`]);
    // }

    if (pdt.ptype === 'child') {
      this.router.navigate([`product/${pdt.parentSlug.name}/${pdt.slug.name}`]);
    } else {
      this.router.navigate([`product/${pdt.slug.name}`]);
    }

    this.searchsubscribed = false;
    this.searchText = '';
}
  fireSearchQuery() {
    if (this.userService.userId === '' && !this.isOpenSearch) {
      this.openLoginModal();
    } else {
      clearTimeout(this.typingTimer);
      if (
        this.searchText.length > 2 &&
        (this.isOpenSearch || this.userService.getUserId())
      ) {
        this.typingTimer = setTimeout(async () => {
          this.showSearchLoader = true;
          this.showNoProducts = false;
          if (!this.searchsubscribed) {
            this.searchsubscribed = true;
          }
          const searchRes =
            await this.searchEngineService.alogoliaSearchProducts(
              this.searchText,
              0,
              'new_search'
            );
          this.processSearchRes(searchRes);
        }, this.doneTypingInterval);
      }
    }
  }

}
